module.exports = __webpack_public_path__ + "img/logo.a3311231.png";